// import { useEffect } from "react";
// import { useBeforeUnload, useNavigate, useLocation } from "react-router-dom";

// /**
//  * Compatible <Prompt /> version for classic <BrowserRouter>
//  */
// export default function Prompt({ when, message }) {
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     if (!when) return;

//     const handleClick = (event) => {
//       // detect internal link clicks
//       const link = event.target.closest("a[href]");
//       if (link && link.href !== window.location.href) {
//         const proceed = window.confirm(
//           typeof message === "function" ? message() : message
//         );
//         if (!proceed) {
//           event.preventDefault();
//         }
//       }
//     };

//     document.addEventListener("click", handleClick);

//     // Handle browser tab close or refresh
//     const handleBeforeUnload = (event) => {
//       if (when) {
//         event.preventDefault();
//         event.returnValue =
//           typeof message === "function" ? message() : message;
//       }
//     };
//     window.addEventListener("beforeunload", handleBeforeUnload);

//     return () => {
//       document.removeEventListener("click", handleClick);
//       window.removeEventListener("beforeunload", handleBeforeUnload);
//     };
//   }, [when, message, location]);

//   return null;
// }

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Compatible <Prompt /> version for classic <BrowserRouter>
 */
export default function Prompt({ when, message }) {
  const location = useLocation();

  useEffect(() => {
    if (!when) return;

    const getMessage = () =>
      typeof message === "function" ? message() : message;

    // Intercept internal link clicks
    const handleClick = (event) => {
      const link = event.target.closest("a[href]");
      if (link && link.href !== window.location.href) {
        const proceed = window.confirm(getMessage());
        if (!proceed) {
          event.preventDefault();
        }
      }
    };
    document.addEventListener("click", handleClick);

    // Handle browser tab close or refresh
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = getMessage();
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Intercept SPA navigations: pushState/replaceState/back/forward
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    const confirmOrBlock = () => window.confirm(getMessage());

    // Patch pushState/replaceState to catch programmatic navigations (e.g., navigate(...))
    window.history.pushState = function (...args) {
      if (confirmOrBlock()) {
        return originalPushState.apply(this, args);
      }
      // blocked
      return;
    };

    window.history.replaceState = function (...args) {
      if (confirmOrBlock()) {
        return originalReplaceState.apply(this, args);
      }
      // blocked
      return;
    };

    // Handle back/forward
    const handlePopState = () => {
      if (!confirmOrBlock()) {
        // revert the back/forward action
        // If user pressed Back, go forward; if Forward, go back.
        // In practice, a single step forward restores the prior entry.
        window.history.go(1);
      }
    };
    window.addEventListener("popstate", handlePopState);

    return () => {
      document.removeEventListener("click", handleClick);
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, [when, message, location]);

  return null;
}